module.exports = __webpack_public_path__ + "assets/img/hot_case_monthly_l1.bcced5bb.png";